export const SAMPLE_CLIENT_ID = 'sample-client';
